import { render, staticRenderFns } from "./AiTestView.vue?vue&type=template&id=935d7acc&scoped=true&"
import script from "./AiTestView.vue?vue&type=script&lang=js&"
export * from "./AiTestView.vue?vue&type=script&lang=js&"
import style0 from "./AiTestView.vue?vue&type=style&index=0&id=935d7acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d7acc",
  null
  
)

export default component.exports